import { render, staticRenderFns } from "./CustomDropdown.vue?vue&type=template&id=40f933fe&"
import script from "./CustomDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports